import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  coordinates: [],
  history: [],     // For undo
  future: [],      // For redo
};

const pdfCoordinatesSlice = createSlice({
  name: 'pdfCoordinates',
  initialState,
  reducers: {
    pdfCoordinates(state, action) {
      state.history.push([...state.coordinates]);
      state.coordinates.push(action.payload);
      state.future = [];
    },
    updateCoordinate(state, action) {
      const { id, newValue } = action.payload;
      state.history.push([...state.coordinates]);
      state.coordinates = state.coordinates.map((coordinate) =>
        coordinate.id === id ? { ...coordinate, ...newValue } : coordinate
      );
      state.future = [];
    },
    deleteCoordinate(state, action) {
      const idToDelete = action.payload;
      state.history.push([...state.coordinates]);
      state.coordinates = state.coordinates.filter(
        (coordinate) => coordinate.id !== idToDelete
      );
      state.future = [];
    },
    updateAllCoordinates(state, action) {
      state.history.push([...state.coordinates]);
      state.coordinates = action.payload;
      state.future = [];
    },
    clearCoordinates(state) {
      state.history.push([...state.coordinates]);
      state.coordinates = [];
      state.future = [];
    },
    bulkUpdateCoordinates(state, action) {
      const updates = action.payload; // [{ id, newValue }]
      state.history.push([...state.coordinates]);
      state.coordinates = state.coordinates.map((coordinate) => {
        const match = updates.find((u) => u.id === coordinate.id);
        return match ? { ...coordinate, ...match.newValue } : coordinate;
      });
      state.future = [];
    },
    undo(state) {
      if (state.history.length > 0) {
        const previous = state.history.pop();
        state.future.unshift([...state.coordinates]);
        state.coordinates = previous;
      }
    },
    redo(state) {
      if (state.future.length > 0) {
        const next = state.future.shift();
        state.history.push([...state.coordinates]);
        state.coordinates = next;
      }
    },
    deleteCoordinatesBySigner(state, action) {
      const signer = action.payload;
      const targetValue = `signer-${String(signer.sequence)}`;
      state.history.push([...state.coordinates]);
      state.coordinates = state.coordinates.filter(
        (coordinate) => coordinate.value !== targetValue
      );
      state.future = [];
    }
  },
});

export const {
  pdfCoordinates,
  deleteCoordinate,
  updateCoordinate,
  updateAllCoordinates,
  clearCoordinates,
  bulkUpdateCoordinates,
  undo,
  redo,
  deleteCoordinatesBySigner,
} = pdfCoordinatesSlice.actions;

export default pdfCoordinatesSlice.reducer;
